import dayjs from "dayjs";
import React from "react";
import Tooltip from "../../../../elements/Tooltip";
import { classNames } from "../../../../../helpers/classNames";
import { lngDetect } from "../../../../../helpers/lngDetect";

const Header = ({ data }) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-semibold">{`${data?.type === "ticket" ? "Ticket" : data?.type === "addons" ? "Add-On" : "N/A"} Name: ${lngDetect(
          data?.name
        )}`}</h1>
        <p className="text-sm text-gray-500 mt-1">
          {dayjs(data?.date).format("MMMM DD, YYYY")} at {dayjs(data?.date).format("hh:mm a")}
        </p>
      </div>
      <div className="flex gap-2">
        <Tooltip message={"payment status"}>
          <span
            className={classNames(
              "text-xs px-2 py-1 rounded",
              data?.type === "paid" ? "bg-primary/10 text-green-800" : "bg-yellow-100 text-yellow-800"
            )}
          >
            {data?.type}
          </span>
        </Tooltip>
        <Tooltip message={"payment method"}>
          <span className="text-xs bg-primary/10 text-green-800 px-2 py-1 rounded">{data?.paymentType}</span>
        </Tooltip>
      </div>
    </div>
  );
};

export default Header;
